var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loader)?_c('DivLoader',{attrs:{"loading_type":'image, list-item-two-line, image, list-item-two-line, image, list-item-two-line, image, list-item-two-line, image, list-item-two-line'}}):_c('div',[_c('BasicDetailsSection'),_c('PersonalDetailsSection'),_c('DocumentsSection'),_c('BusinessDetailsSection')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }